export function computePlatformChatSessionHasNew(options: {
  participantCount: number;
  mostRecentMessageId: string | null;
  mostRecentAuthorUserId: string | null;
  mostRecentRole: string | null;
  lastSeenMessageId: string | undefined;
  currentUserId: string | undefined;
  isActiveSession: boolean;
}): boolean {
  const {
    participantCount,
    mostRecentMessageId,
    mostRecentAuthorUserId,
    mostRecentRole,
    lastSeenMessageId,
    currentUserId,
    isActiveSession,
  } = options;

  if (isActiveSession || participantCount <= 1) {
    return false;
  }

  if (mostRecentMessageId == null || mostRecentMessageId.length === 0) {
    return false;
  }

  if (lastSeenMessageId == null) {
    return false;
  }

  if (mostRecentMessageId === lastSeenMessageId) {
    return false;
  }

  if (
    currentUserId != null &&
    mostRecentAuthorUserId != null &&
    mostRecentAuthorUserId === currentUserId
  ) {
    return false;
  }

  if (mostRecentRole === 'ASSISTANT') {
    return true;
  }

  return (
    mostRecentAuthorUserId != null && mostRecentAuthorUserId !== currentUserId
  );
}
